import { PILLARS, PILLAR_CLS } from "@/lib/constants";

export function PillarBalance({ ideas, active, onPick }) {
  const used = ideas.filter((i) => i.status === "USED");
  const counts = Object.fromEntries(PILLARS.map((p) => [p, used.filter((i) => i.pillar === p).length]));
  const max = Math.max(1, ...Object.values(counts));
  const avg = used.length / PILLARS.length;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 mb-4" data-testid="pillar-balance">
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs font-bold uppercase tracking-wide text-slate-400">Equilíbrio do feed por pilar (temas já usados)</p>
        {active && <button className="text-xs text-[#3457d5] font-semibold" data-testid="pillar-clear" onClick={() => onPick("")}>Limpar filtro</button>}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-6 gap-y-2">
        {PILLARS.map((p) => {
          const low = used.length >= PILLARS.length && counts[p] < avg * 0.5;
          return (
            <button key={p} onClick={() => onPick(active === p ? "" : p)} data-testid={`pillar-bar-${p}`}
              className={`text-left rounded-lg px-2 py-1 transition-colors ${active === p ? "bg-slate-100" : "hover:bg-slate-50"}`}>
              <div className="flex items-center justify-between text-xs">
                <span className={`font-medium ${low ? "text-rose-600" : "text-slate-600"}`}>{p}{low ? " · pouco usado" : ""}</span>
                <span className="text-slate-400">{counts[p]}</span>
              </div>
              <div className="mt-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
                <div className="h-full rounded-full pf-gradient transition-[width] duration-500" style={{ width: `${(counts[p] / max) * 100}%` }} />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function PillarSelect({ value, onChange, testid, className = "" }) {
  return (
    <select data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)}
      className={`rounded-full border-0 px-2 py-0.5 text-[11px] font-medium outline-none cursor-pointer ${value ? PILLAR_CLS[value] : "bg-slate-100 text-slate-500"} ${className}`}>
      <option value="">Sem pilar</option>
      {PILLARS.map((p) => <option key={p} value={p}>{p}</option>)}
    </select>
  );
}
